import styled from 'styled-components';

export const MentionDropdown = styled.div`
  max-height: inherit;
  overflow: hidden;
  border-radius: 8px;

  & > div {
    position: static;
    width: 280px;
    bottom: auto;
    max-height: inherit;
    overflow-y: auto;
    box-shadow: ${({ theme }) => theme.shadows.dropdown};
  }
`;
